import { render, staticRenderFns } from "./BenefitInfoBlock.vue?vue&type=template&id=4634b526&scoped=true&"
import script from "./BenefitInfoBlock.vue?vue&type=script&lang=js&"
export * from "./BenefitInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./BenefitInfoBlock.vue?vue&type=style&index=0&id=4634b526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634b526",
  null
  
)

export default component.exports